<template>
  <v-container fluid height="100%">
    <v-row v-if="error" align="center" justify="center" style="margin-top: 10%">
      <v-col class="text-center" cols="12">
        <h1 class="text-h3 font-weight-light mb-2">
          {{ $t(title) }}
        </h1>
        <h4 class="text-h5">{{ type }}</h4>
        <h4 class="text-h5">{{ description }}</h4>
        <v-progress-circular
          :size="100"
          :width="8"
          style="margin-top: 8px"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row v-else align="center" justify="center" style="margin-top: 15%">
      <v-col class="text-center" cols="12">
        <v-progress-circular :size="100" :width="8" color="primary" indeterminate> </v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  data: () => ({
    error: false,
    title: "Erreur lors de l'authentification",
    type: 'Utilisateur non cotisant',
    description: 'Vous allez être redirigé vers le site du Cetim',
  }),
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapMutations(['resetUser', 'resetState']),
    timeOutlogOut() {
      // Logout après 3 secondes
      setTimeout(() => {
        this.resetUser();
        window.localStorage.clear();
        this.resetState();
        this.$authService.signOut();
      }, '3000');
    },
  },
  mounted() {
    try {
      this.error = true;
      if (
        ['true', 'TRUE', 'True'].indexOf(this.user.profile.isCotisant) >= 0 ||
        this.user.profile.source == 'AzureAD'
      ) {
        this.title = 'Déconnexion';
        this.type = '';
      }
      this.timeOutlogOut();
    } catch (err) {
      this.timeOutlogOut();
      console.error(err);
    }
  },
};
</script>
